import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import HeroCarousel from '../Common/HeroCarousel';
import { FaMusic, FaVideo, FaPalette, FaArrowLeft } from 'react-icons/fa';
import image1 from '../../Assets/image 1.png';
import image2 from '../../Assets/image 2.png';
import image3 from '../../Assets/image 3.png';

const WorshipCreativeArts = () => {
  const navigate = useNavigate();

  const ministryAreas = [
    {
      id: 1,
      icon: <FaMusic className="text-3xl text-pink-500" />,
      title: 'Worship Team',
      description: 'Lead congregational worship through vocals, instruments, and spirit-led ministry that creates an atmosphere for God\'s presence to manifest.',
      image: image1
    },
    {
      id: 2,
      icon: <FaVideo className="text-3xl text-orange-500" />,
      title: 'Media Ministry',
      description: 'Operating cameras, sound systems, lighting, and live streaming to broadcast God\'s message to both-in-person and online audiences worldwide',
      image: image2
    },
    {
      id: 3,
      icon: <FaPalette className="text-3xl text-teal-500" />,
      title: 'Creative arts',
      description: 'Expressing worship through visual arts, dance, drama, banners, and creative presentations that enhance the worship experience.',
      image: image3
    }
  ];

  return (
    <>
      <Header />
      
      {/* Hero Section */}
      <HeroCarousel 
        title="Ministries"
        subtitle="Discover how you can grow, serve, and connect through our specialized ministries"
        height="h-[500px]"
        contentPosition="bottom"
      />

      {/* Back Button and Content Section */}
      <div className="bg-gray-50 py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          {/* Back Button */}
          <button 
            onClick={() => navigate('/ministries')}
            className="flex items-center gap-2 text-primary hover:text-blue-700 mb-8 font-sf-pro font-medium"
          >
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
              <FaArrowLeft className="text-white text-sm" />
            </div>
            Back
          </button>

          {/* Title and Description */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Worship & Creative Arts Ministries</h2>
            <p className="text-gray-700 text-lg max-w-3xl mx-auto font-sf-pro">
              Using our creative gifts to lead others into the presence of God through music, media, and artistic expression.
            </p>
          </div>

          {/* Ministry Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {ministryAreas.map((area) => (
              <div key={area.id} className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="relative h-48">
                  <img 
                    src={area.image} 
                    alt={area.title} 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    {area.icon}
                    <h3 className="text-xl font-bold">{area.title}</h3>
                  </div>
                  <p className="text-gray-600 text-sm font-sf-pro leading-relaxed">
                    {area.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Contact Button */}
          <div className="flex justify-center">
            <button 
              onClick={() => navigate('/ministries/join')}
              className="bg-black text-white px-8 py-3 rounded-lg font-medium hover:bg-gray-900 transition font-sf-pro"
            >
              Join us
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default WorshipCreativeArts;
